import React from "react";
import optionsIcon from "../../assets/images/interface/options.svg";
import close from "../../assets/images/interface/close.svg";


const OptionsModal = ({ transparencyRef, optionsModalClass, triggerOptions, mapStyle, hybridStyle, swapStyle, setOpacity, autoStyle, transparency }) => {
  return (
    <div className={["optionsModal", optionsModalClass].join(' ')}>
      <div className="modal-header">
        <img height="30px" src={optionsIcon} alt="?"></img>
        <div className="optionsModal-title">Ajustes mapa</div>
        <img
          onClick={triggerOptions}
          className="modal-close"
          src={close}
          alt="X"
        ></img>
      </div>

      <div className="optionsModal-body">
        <div className="optionsModal-option">
          <div className="optionsModal-text" style={{ marginBottom: "25px" }}>
            Estilo de mapa
          </div>
          <select
            defaultValue={autoStyle ? "auto" : mapStyle}
            onChange={(event) => swapStyle(event)}
            className="home-filters-dropdown shadow2"
          >
            <option value="auto">Político</option>
            <option value={hybridStyle}>Satélite</option>
          </select>
        </div>
        <div className="optionsModal-option">
          <div className="optionsModal-text">Transparencia de lotes</div>
          <input
            ref={transparencyRef}
            defaultValue={transparency}
            onChange={(event) => setOpacity(event)}
            className="optionsModal-range"
            type="range"
            min="0"
            max="100"
          ></input>
          <div className="optionsModal-rangeNumber">
            {transparency} %
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptionsModal;
